module.exports = __webpack_public_path__ + "static/media/ui_ux_design.a956b8f9.svg";